/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext } from 'react';
import { isMac } from '../../../../services/ClientService';
import { defineMessages, useIntl } from 'react-intl';
import { Flex, ListItem, OrderedList } from '@getgo/chameleon-chakra-ui';
import { SessionContext } from '../../../../context/SessionContext';
import { Spacing } from '../../../../themes/GoToTheme';
import { GoToJoinHeading } from '../../../JoinPages/GoToPages/Components/Heading/GoToJoinHeading';
import { buildNativeDownloadUrl } from '../../../../services/UrlService';
import { GoToLink } from '../../../JoinPages/GoToPages/Components/Texts/GoToLink';
import {
  TelemetryAction,
  TelemetryComponent,
  TelemetryState,
  useSendTelemetry,
} from '../../../../hooks/useSendTelemetry';
import { GoToText } from '../../../Text/GoToText';

const messages = defineMessages({
  step1: {
    id: 'goto.downloadInstructions.installInstructions.step1',
  },
  step2MacOnly: {
    id: 'goto.downloadInstructions.installInstructions.step2MacOnly',
  },
  step3: {
    id: 'goto.downloadInstructions.installInstructions.step3',
  },
  heading: {
    id: 'goto.downloadInstructions.heading',
  },
  ariaInstallInstructionHeading: {
    id: 'goto.downloadInstructions.installInstructions.ariaHeading',
  },
  troubleshootingHeading: {
    id: 'goto.downloadInstructions.troubleshooting.heading',
  },
  troubleshootingAriaHeading: {
    id: 'goto.downloadInstructions.troubleshooting.ariaHeading',
  },
  tryAgainLink: {
    id: 'goto.downloadInstructions.troubleshooting.tryAgainLink',
  },
});

export const macDownloadFileName = 'GoTo Opener.dmg';
export const windowsDownloadFileName = 'GoToMeeting Opener.exe';
const downloadFileName = () =>
  isMac ? macDownloadFileName : windowsDownloadFileName;

export const GoToDownloadInstructions: React.FC = () => {
  const { formatMessage: f } = useIntl();
  const { openerLaunchToken } = useContext(SessionContext);
  const sendTelemetry = useSendTelemetry();
  return (
    <>
      <GoToJoinHeading greeting heading={f(messages.heading)} />
      <OrderedList aria-label={f(messages.ariaInstallInstructionHeading)}>
        <ListItem>
          <GoToText>
            {f(messages.step1, {
              appFileName: <span>{downloadFileName()}</span>,
            })}
          </GoToText>
        </ListItem>
        {isMac && (
          <ListItem>
            <GoToText>{f(messages.step2MacOnly)}</GoToText>
          </ListItem>
        )}
        <ListItem>
          <GoToText>{f(messages.step3)}</GoToText>
        </ListItem>
      </OrderedList>
      <Flex direction='row' marginTop={Spacing.CoreLayout5}>
        <GoToText marginRight={2}>
          {f(messages.troubleshootingHeading)}
        </GoToText>
        <GoToLink
          href={buildNativeDownloadUrl(openerLaunchToken)}
          onClick={sendTelemetry(
            TelemetryComponent.Native,
            TelemetryAction.Retry,
            TelemetryState.DownloadInstructions
          )}
        >
          {f(messages.tryAgainLink)}
        </GoToLink>
      </Flex>
    </>
  );
};
